import { Component, Input, OnInit } from '@angular/core';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { ModuleManager } from 'src/shared/models/module-manager';
import { TimeInterval } from 'src/shared/models/module-manager/module-manager-settings.models';

@Component({
    selector: 'cv-cxone-interval-selector',
    templateUrl: './cxone-interval-selector.component.html',
    styleUrls: ['./cxone-interval-selector.component.scss']
})
export class CxoneIntervalSelectorComponent implements OnInit {

    @Input() moduleManager: ModuleManager;
    @Input() context?: {
        settingsSelectedInterval: TimeInterval,
        viewStateLoaded: () => boolean,
        onIntervalChange: () => any
    };

    intervalTypes: { id: number; order: number; name: string }[] = [];
    intervalTypesMap = new Map<number, { id: number; order: number; name: string }>();

    constructor(
        private localizationService: CVLocalizationService,
        private config: CvConfigurationService
    ) { }

    async ngOnInit(): Promise<void> {
        this.buildIntervalTypesArr();
    }

    async buildIntervalTypesArr() {
        const text = await this.localizationService.GetSection("Controls");
        this.intervalTypes.push({ order: 1, id: TimeInterval.FifteenMinute, name: text.get("Fifteen_Minute") ?? "15 minutes" });
        this.intervalTypes.push({ order: 2, id: TimeInterval.HalfHour, name: text.get("Half_Hour") ?? "30 minutes" });
        this.intervalTypes.push({
            order: 3, id: TimeInterval.Hour,
            name: this.config.isCxOne ? text.get("Hourly") ?? "Hourly" : text.get("Hour") ?? "Hour"
        });
        this.intervalTypes.push({ order: 4, id: TimeInterval.Day,
            name: this.config.isCxOne ? text.get("Daily") ?? "Daily" : text.get("Day") ?? "Day" });
        this.intervalTypes.push({ order: 6, id: TimeInterval.Week,
            name: this.config.isCxOne ? text.get("Weekly") ?? "Weekly" : text.get("Week") ?? "Week" });
        this.intervalTypes.push({ order: 7, id: TimeInterval.Month,
            name: this.config.isCxOne ? text.get("Monthly") ?? "Monthly" : text.get("Month") ?? "Month" });
        this.intervalTypesMap = new Map(this.intervalTypes.map(i => [i.id, i]));
    }

    getSelectedInterval() {
        return this.intervalTypesMap.get(this.context.settingsSelectedInterval);
    }
}
